import { render, staticRenderFns } from "./tickets.vue?vue&type=template&id=2e430e12&scoped=true"
import script from "./tickets.vue?vue&type=script&lang=js"
export * from "./tickets.vue?vue&type=script&lang=js"
import style0 from "./tickets.vue?vue&type=style&index=0&id=2e430e12&prod&lang=css"
import style1 from "./tickets.vue?vue&type=style&index=1&id=2e430e12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e430e12",
  null
  
)

export default component.exports